import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,{staticClass:"cooldown-label-btn",attrs:{"small":"","rounded":"","depressed":""}},[_c(VIcon,{staticClass:"mr-1",staticStyle:{"color":"black !important"},attrs:{"small":""}},[_vm._v("mdi-clock-alert-outline")]),_c('span',[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }